<template>
  <footer>
	<div class="footer-top">
	  <nav class="footer-column-1">
		<ul class="footer-list">
		  <li v-for="(link, index) in column1Links" :key="index">
			<a class="footer-link" :href="link.url" :target="link.external ? '_blank' : ''">
			  {{ link.text }}
			</a>
		  </li>
		</ul>
	  </nav>

	  <nav class="footer-column-2">
		<ul class="footer-list">
		  <li v-for="(link, index) in column2Links" :key="index">
			<a class="footer-link" 
			   :href="link.url" 
			   :target="link.external ? '_blank' : ''"
			   :id="link.id"
			   @click="link.onClick">
			  {{ link.text }}
			</a>
		  </li>
		</ul>
	  </nav>
	  
	  <nav class="footer-column-3">
		<ul class="footer-list">
		  <li v-for="(link, index) in column3Links" :key="index">
			<a class="footer-link" 
			   :href="link.url" 
			   :target="link.external ? '_blank' : ''"
			   :id="link.id"
			   @click="link.onClick">
			  {{ link.text }}
			</a>
		  </li>
		</ul>
	  </nav>

	  <nav class="footer-social">
		<ul class="footer-social-links">
		  <li v-for="social in socialLinks" :key="social.name">
			<a class="footer-social-icon" :href="social.url" target="_blank">
			  <img :src="social.imageSrc" 
				   :alt="social.alt" 
				   class="footer-social-icon">
			</a>
		  </li>
		</ul>
	  </nav>
	  <br class="cleaner" />
	</div>
	
	<div class="footer-bottom">
	  <p>© Cambro | Trusted Durability</p>
	</div>
  </footer>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Footer',
  data() {
	return {
	  column1Links: [
		{ text: 'International Resource Centre', url: '/international-resource-centre/' },
		{ text: 'Sustainability', url: '/sustainability/' },
		{ text: 'Careers', url: 'https://careers.cambro.com/', external: true },
	  ],
	  column2Links: [
		{ text: 'Contact Us', url: '/contact-us/' },
		{ text: 'Privacy', url: '/privacy/' },
		{ text: 'Terms', url: '/terms/' }
	  ],
	  column3Links: [
		{ text: 'Warranty', url: '/warranty/' },
		{ text: 'BPA Information', url: '/globalassets/page-content/footer/bisphenol-a-bpa-information-updated-11-29-23.pdf' },
		{ text: 'California Supply Chain Act', url: 'https://assets.brandfolder.com/psnfly-8vmtdc-nxg7f/original/LEGAL - California Supply Chain Act Disclosure.pdf', external: true }
	  ],
	  socialLinks: [
		{ 
		  name: 'Instagram', 
		  url: 'https://www.instagram.com/cambromfg/',
		  imageSrc: require('@/assets/images/social-instagram.png'),
		  alt: 'Cambro Instagram'
		},
		{ 
		  name: 'LinkedIn', 
		  url: 'http://www.linkedin.com/company/cambro-manufacturing/',
		  imageSrc: require('@/assets/images/social-linkedin.png'),
		  alt: 'Cambro LinkedIn'
		},
		{ 
		  name: 'X', 
		  url: 'https://twitter.com/Cambro1/',
		  imageSrc: require('@/assets/images/social-x.png'),
		  alt: 'Cambro on X'
		},
		{ 
		  name: 'YouTube', 
		  url: 'https://www.youtube.com/user/iamcambro/',
		  imageSrc: require('@/assets/images/social-youtube.png'),
		  alt: 'Cambro on YouTube'
		},
		{ 
		  name: 'Pinterest', 
		  url: 'http://pinterest.com/CambroMfg/',
		  imageSrc: require('@/assets/images/social-pinterest.png'),
		  alt: 'Cambro on Pinterest'
		},
		{ 
		  name: 'Facebook', 
		  url: 'http://www.facebook.com/CambroMfg/',
		  imageSrc: require('@/assets/images/social-facebook.png'),
		  alt: 'Cambro Facebook'
		},
		{ 
		  name: 'TikTok', 
		  url: 'http://tiktok.com/@cambromfg/',
		  imageSrc: require('@/assets/images/social-tiktok.png'),
		  alt: 'Cambro Tik Tok'
		},
		{ 
		  name: 'CambroEats', 
		  url: 'https://cambroeats.com/',
		  imageSrc: require('@/assets/images/social-podcast.png'),
		  alt: 'CambroEats'
		}
	  ]
	}
  }
})
</script>